import { prettyFloat } from './number';
import { todayStart } from './time';
/**
 * @function timezoneOffsetToUnix - сдвиг таймзоны в Unix
 * @param mintime: Unixtime | null - значение
 * @return Unixtime
 */
export function timezoneOffsetToUnix(mintime) {
    if (mintime == null) {
        return -todayStart().getTimezoneOffset() * 60;
    }
    return -new Date(mintime * 1e3).getTimezoneOffset() * 60;
}
/**
 * @function any2unix - Всё в Unixtime
 * @param any: Date | number | string - значение
 * @return Unixtime
 */
export function any2unix(any) {
    if (typeof any === 'object' && 'getMonth' in any)
        return Math.floor(any.getTime() / 1e3);
    if (typeof any === 'string') {
        const any_to_float = parseInt(any, 10);
        if (any_to_float > 1e11)
            return Math.floor(any_to_float / 1e3);
        return any_to_float;
    }
    if (typeof any === 'number') {
        if (any > 1e11)
            return Math.floor(any / 1e3);
        return any;
    }
    throw `Cannot convert ${any} (typeof=${typeof any}) to date!`;
}
/**
 * @function todayToUnix - сегодня в Unixtime
 * @return Unixtime
 */
export function todayToUnix() {
    return any2unix(new Date());
}
/**
 * @function dayStartToUnix - начало дня в Unixtime
 * @param dt: Date | null - значение
 * @return Unixtime
 */
export function dayStartToUnix(dt) {
    const t = dt != null ? new Date(dt) : new Date();
    t.setHours(0, 0, 0, 0);
    return any2unix(t);
}
/**
 * @function todayStartToUnix - начало сегодняшнего дня в Unixtime
 * @return Unixtime
 */
export function todayStartToUnix() {
    return dayStartToUnix(null);
}
/**
 * @function yesterdayStartToUnix - начало вчерашнего дня в Unixtime
 * @return Unixtime
 */
export function yesterdayStartToUnix() {
    return dayStartToUnix(new Date(Date.now() - 24 * 60 * 60e3));
}
/**
 * @function
 * начало месяца в Unixtime
 * @return Unixtime
 */
export function monthStartToUnix() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return any2unix(new Date(y, m, 1));
}
/**
 * @function
 * начало предыдущего месяца в Unixtime
 * @return Unixtime
 */
export function prevMonthStartToUnix() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return any2unix(new Date(y, m - 1, 1));
}
/**
 * @function dayEndToUnix - конец дня в Unixtime
 * @param dt: Date | null - значение
 * @return Unixtime
 */
export function dayEndToUnix(dt) {
    const t = dt != null ? new Date(dt) : new Date();
    t.setHours(23, 59, 59, 999);
    return any2unix(t);
}
/**
 * @function todayEndToUnix - конец сегодняшнего дня в Unixtime
 * @return Unixtime
 */
export function todayEndToUnix() {
    return dayEndToUnix(null);
}
/**
 * @function yesterdayEndToUnix - конец вчерашнего дня в Unixtime
 * @return Unixtime
 */
export function yesterdayEndToUnix() {
    return dayEndToUnix(new Date(Date.now() - 24 * 60 * 60e3));
}
/**
 * @function
 * конец месяца в Unixtime
 * @return Unixtime
 */
export function monthEndToUnix() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return any2unix(new Date(y, m + 1, 0));
}
/**
 * @function
 * конец предыдущего месяца в Unixtime
 * @return Unixtime
 */
export function prevMonthEndToUnix() {
    const date = new Date(), y = date.getFullYear(), m = date.getMonth();
    return any2unix(new Date(y, m, 0));
}
/**
 * @function unixToIsoString - время в формате ISO 2021-03-03T05:23:29.243Z
 * @param time: Unixtime - значение
 * Время по гринвичу
 * @return string
 */
export function unixToIsoString(time) {
    return new Date(time * 1e3).toISOString();
}
/**
 * @function unixToDateTime - Unix в строку такого вида 05.12.2020 07:05:01
 * @param time: Unixtime - время
 * @param with_seconds: boolean - с секундами?
 * @param day_parser: string = '.' - символ между датами
 * @param minutes_parser: string = ':' - символ между минутами
 * @return string
 */
export function unixToDateTime(time, with_seconds = false, day_parser = '.', minutes_parser = ':') {
    const date = new Date(time * 1e3);
    return ((date.getDate() < 10
        ? '0' + date.getDate().toString()
        : date.getDate().toString()) +
        day_parser +
        (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1).toString()
            : (date.getMonth() + 1).toString()) +
        day_parser +
        date.getFullYear().toString() +
        ' ' +
        (date.getHours() < 10
            ? '0' + date.getHours().toString()
            : date.getHours().toString()) +
        minutes_parser +
        (date.getMinutes() < 10
            ? '0' + date.getMinutes().toString()
            : date.getMinutes().toString()) +
        (with_seconds
            ? minutes_parser +
                (date.getSeconds() < 10
                    ? '0' + date.getSeconds().toString()
                    : date.getSeconds().toString())
            : ''));
}
/**
 * @function unixToDate - Unixtime в 05.12.2020
 * @param time: Unixtime - время
 * @param day_parser: string = '.' - символ между датами
 * @return Unixtime
 */
export function unixToDate(time = todayToUnix(), day_parser = '.') {
    const date = new Date(time * 1e3);
    return ((date.getDate() < 10
        ? '0' + date.getDate().toString()
        : date.getDate().toString()) +
        day_parser +
        (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1).toString()
            : (date.getMonth() + 1).toString()) +
        day_parser +
        date.getFullYear().toString());
}
/**
 * @function unixToInputDate - Unixtime в 2020-12-05
 * @param time: Unixtime - время
 * @param parser: разделитель, по умолчанию '-'
 * @return string
 * Функция нужная для поля ввода типа date
 */
export function unixToInputDate(time = todayToUnix(), parser = '.') {
    const date = new Date(time * 1e3);
    return (date.getFullYear().toString() +
        parser +
        (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1).toString()
            : (date.getMonth() + 1).toString()) +
        parser +
        (date.getDate() < 10
            ? '0' + date.getDate().toString()
            : date.getDate().toString()));
}
/**
 * @function unixToInputTime - Unixtime в 08:00
 * @param time: Unixtime - время
 * @param with_seconds: c секудами
 * @return string
 * Функция нужная для поля ввода типа time
 */
export function unixToInputTime(time = todayToUnix(), with_seconds = false) {
    const date = new Date(time * 1e3);
    return ((date.getHours() < 10
        ? '0' + date.getHours().toString()
        : date.getHours().toString()) +
        ':' +
        (date.getMinutes() < 10
            ? '0' + date.getMinutes().toString()
            : date.getMinutes().toString()) +
        (with_seconds
            ? ':' +
                (date.getSeconds() < 10
                    ? '0' + date.getSeconds().toString()
                    : date.getSeconds().toString())
            : ''));
}
export function inputTime2UnixWithPreserveDate(input_time, unixtime) {
    const split_time = input_time.split(':');
    const new_hour = split_time != null ? parseInt(split_time[0], 10) : 0;
    const new_min = split_time != null ? parseInt(split_time[1], 10) : 0;
    const date = new Date(unixtime * 1e3);
    return any2unix(date.setHours(new_hour, new_min));
}
/**
 * @function inputDateToUnixWithPreserveTime - обратная функция преобразования для элемента input
 * c типом date из 2020-12-05 с сохранением времени 10:42
 * @param input_date: string - значение
 * @param unixtime: Unixtime - время которое редактируем
 * @return Unixtime
 */
export function inputDateToUnixWithPreserveTime(input_date, unixtime) {
    const split_date = input_date.split('.');
    const new_year = split_date != null ? parseInt(split_date[2], 10) : 0;
    const new_month = split_date != null ? parseInt(split_date[1], 10) - 1 : 0;
    const new_day = split_date != null ? parseInt(split_date[0], 10) : 0;
    const date = new Date(unixtime * 1e3);
    return any2unix(date.setFullYear(new_year, new_month, new_day));
}
/**
 * @function inputDateToUnix - обратная функция преобразования для элемента input c типом date из 2020-12-05
 * @param input_date: string - значение
 * @return Unixtime
 */
export function inputDateToUnix(input_date) {
    const split_date = input_date.split('.');
    return any2unix(new Date(parseInt(split_date[0], 10), parseInt(split_date[1], 10) - 1, parseInt(split_date[2], 10)));
}
/**
 * @function inputTimeToUnix - обратная функция преобразования для элемента input c типом time 10:42
 * @param input_time: string - значение
 * @param unixtime: Unixtime - время которое редактируем
 * @return Unixtime
 */
export function inputTimeToUnix(input_time, unixtime) {
    const split_time = input_time.split(':');
    const hours = split_time[0] != null ? parseInt(split_time[0], 10) : 0;
    const minutes = split_time[1] != null ? parseInt(split_time[1], 10) : 0;
    const seconds = split_time[2] != null ? parseInt(split_time[2], 10) : 0;
    const date = new Date(unixtime * 1e3);
    return any2unix(date.setHours(hours, minutes, seconds));
}
/**
 * @function inputStringDayToUnix - прислали число дней, посчитали количество секунд
 * @param input_date: string - значение
 * @return Unixtime
 */
export function inputStringDayToUnix(input_date) {
    return any2unix(new Date(parseInt(input_date, 10) * 24 * 60 * 60 * 1e3));
}
/**
 * @function unixToDayString - Показываем количество дней пользователю
 * @param time: Unixtime - время
 * @return string
 */
export function unixToDayString(time = todayToUnix()) {
    const days = time / 24 / 60 / 60;
    return prettyFloat(days, 0);
}
export function unixToMonth(time) {
    if (time == null) {
        return 0;
    }
    const months = time / 24 / 60 / 60 / 30;
    return Math.floor(months);
}
export function month2Unix(month) {
    return month == null ? null : month * 30 * 24 * 60 * 60;
}
/**
 * @function unixToDay - Показываем количество дней пользователю
 * @param time: Unixtime - время
 * @return string
 */
export function unixToDay(time) {
    if (time == null) {
        return 0;
    }
    return time / 24 / 60 / 60;
}
/**
 * @function unixToDay - Показываем количество дней пользователю
 * @param time: Unixtime - время
 * @return string
 */
export function dayToUnix(time) {
    return time * 24 * 60 * 60;
}
/**
 * @function
 * Приводим время ретранслятора в unixtime
 * @param time: string - время в формате YYYY.MM.DD HH:mm
 * Ретранслятор живёт в тайм-зоне +4 часа
 * @return Unixtime
 */
export function retranslatorTime2Unix(time) {
    const match = time.match(/^(\d\d\d\d)\.(\d\d)\.(\d\d) (\d\d):(\d\d)/);
    return (new Date(+match[1], +match[2] - 1, +match[3], +match[4], +match[5]).getTime() /
        1e3 -
        new Date().getTimezoneOffset() * 60 -
        4 * 60 * 60);
}
export function unixToMskDateTime(time) {
    const _time = time + 3 * 60 * 60; //у нас на 3 часа больше
    return unixToInputDate(_time) + ' ' + unixToInputTime(_time, true);
}
export function unixToMskDate(time) {
    const _time = time + 3 * 60 * 60; //у нас на 3 часа больше
    return unixToInputDate(_time);
}
